import { useQueryApi } from "api/hooks.ts";
import { userStructureApi } from "api/TenantSlug/UserStructure/api";

import GetFormStructuresRequest = App.Http.Requests.FormStructure.GetFormStructuresRequest;
import GetFormStructuresResponse = App.Http.Responses.FormStructure.GetFormStructuresResponse;
import GetFormStructureResponse = App.Http.Responses.FormStructure.GetFormStructureResponse;

// Query to get a list of form objects
export const useGetUserStructuresQuery = (request: GetFormStructuresRequest, options = {}) => {
    return useQueryApi<GetFormStructuresResponse>({
        queryKey: ["getFormStructures", request],
        queryFn: () => userStructureApi.index(request),
        ...options,
    });
};

export const useGetRegistrationStructureQuery = (systemName: string, options = {}) => {
    return useQueryApi<GetFormStructureResponse>({
        queryKey: ["getRegistrationStructure", systemName],
        queryFn: () => userStructureApi.registration(systemName),
        ...options,
    });
};
